import { render, staticRenderFns } from "./ImportFileModal.vue?vue&type=template&id=67821c47&scoped=true&"
import script from "./ImportFileModal.vue?vue&type=script&lang=js&"
export * from "./ImportFileModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportFileModal.vue?vue&type=style&index=0&id=67821c47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67821c47",
  null
  
)

export default component.exports